(function ($) {
  $(document).ready(function () {
    var formationId = '';
    var variationId = '';
    var userId = '';

    function addFormationDataToUrl(url) {
      if (!url || !formationId) {
        return url;
      }

      try {
        var parsedUrl = new URL(url, window.location.origin);

        parsedUrl.searchParams.set('formationId', formationId);
        if (variationId) {
          parsedUrl.searchParams.set('variationId', variationId);
        }
        if (userId) {
          parsedUrl.searchParams.set('userId', userId);
        }

        return parsedUrl.toString();
      } catch (error) {
        var separator = url.indexOf('?') === -1 ? '?' : '&';
        var query = 'formationId=' + encodeURIComponent(formationId);

        if (variationId) {
          query += '&variationId=' + encodeURIComponent(variationId);
        }
        if (userId) {
          query += '&userId=' + encodeURIComponent(userId);
        }

        return url + separator + query;
      }
    }

    function updateHustleButtonUrls($scope) {
      $scope.find('a.hustle-button-cta').each(function () {
        var $button = $(this);
        var href = $button.attr('href');

        if (!href) {
          return;
        }

        $button.attr('href', addFormationDataToUrl(href));
      });
    }

    $(document).on('click', '.popup-coursalacarte', function () {
      formationId = $(this).attr('data-formation-id') || '';
      variationId = $(this).attr('data-variation-id') || '';
      userId = $(this).attr('data-user-id') || '';

      setTimeout(function () {
        updateHustleButtonUrls($('.hustle-popup.hustle-show, .hustle-ui.hustle-show'));
      }, 250);
    });

    // Hustle can refresh its CTA after the popup is displayed. Apply the
    // parameters once more immediately before the visitor leaves for Zoho.
    $(document).on('click', 'a.hustle-button-cta', function () {
      var $button = $(this);
      var href = $button.attr('href');

      if (href && formationId) {
        $button.attr('href', addFormationDataToUrl(href));
      }
    });

    $(document).on('hustle:module:displayed', function (event, module) {
      if (!formationId) {
        return;
      }

      updateHustleButtonUrls($(module).closest('.hustle-ui').addBack('.hustle-ui'));
    });
  });
})(jQuery);
